export default "__VITE_ASSET__DB$3DDbZ__"